import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = ({ content = {} }) => {
  return (
    <footer data-testid="main-footer" className="relative bg-brand-navy text-white/80 grain overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2 max-w-sm">
          <div className="flex items-center gap-3">
            <span className="w-16 h-16 rounded-full bg-white grid place-items-center shrink-0 overflow-hidden ring-2 ring-brand-gold shadow-md">
              <img src="/logo_mark.png" alt="WEDDING EVENTS logo" className="w-full h-full object-cover scale-105" />
            </span>
            <h3 className="font-serif text-2xl text-white">WEDDING EVENTS</h3>
          </div>
          <p className="overline mt-2">One Stop Solution</p>
          <p className="mt-4 text-sm leading-relaxed text-white/70">
            A Jammu-based event & wedding management agency crafting unforgettable weddings, social celebrations
            and corporate events across India.
          </p>

        </div>

        <div>
          <p className="overline mb-4">Explore</p>
          <ul className="space-y-2.5 text-sm">
            {[["Home","/"],["About","/about"],["Services","/services"],["Gallery","/gallery"],["Book Event","/booking"]].map(([t,u]) => (
              <li key={u}><Link to={u} className="hover:text-brand-gold transition-colors">{t}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <p className="overline mb-4">Get in Touch</p>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3"><Phone size={16} className="text-brand-gold shrink-0 mt-0.5" /><span>{content.phone || "+91 70065 34892"}{content.phone2 ? ` / ${content.phone2}` : ""}</span></li>
            <li className="flex gap-3"><Mail size={16} className="text-brand-gold shrink-0 mt-0.5" /><span>{content.email || "hello@weddingevents.in"}</span></li>
            <li className="flex gap-3"><MapPin size={16} className="text-brand-gold shrink-0 mt-0.5" /><span>{content.address || "Gandhi Nagar, Jammu, J&K, India"}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/50">
          <span>© {new Date().getFullYear()} WEDDING EVENTS, Jammu. All rights reserved.</span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-brand-gold transition-colors">Admin Login</Link>
        </div>
      </div>
    </footer>
  );
};
